<template>
  <component-wrapper>
    <grid-container-fi>
      <div class="fi-col-span-12 fi-col-start-1 lg:fi-col-span-7 lg:fi-col-start-2">
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="fields.subheadline && (fields.subheadline.value || fields.subheadline.editable)"
          class="link-list-fi__subheadline"
          v-html="isEditMode ? fields.subheadline.editable : fields.subheadline.value"
        />
        <h3
          v-if="fields.headline && (fields.headline.value || fields.headline.editable)"
          class="link-list-fi__headline"
          v-html="isEditMode ? fields.headline.editable : fields.headline.value"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>

      <div
        v-if="fields.linkListElements?.length"
        class="fi-col-span-12 fi-col-start-1 lg:fi-col-span-10 lg:fi-col-start-2"
      >
        <ul class="link-list-fi__list">
          <li
            v-for="(link, idx) in fields.linkListElements"
            :key="idx"
          >
            <a
              v-if="!isEditMode && link.fields?.link?.value?.text"
              :href="link.fields.link.value.href || link.fields.link.value.url"
              :target="link.fields.link.value.target"
              :rel="
                link.fields.link.value.url && link.fields.link.value.target === '_blank'
                  ? 'noopener noreferrer'
                  : null
              "
              class="link-list-fi__link fi-text-24"
            >
              <span class="link-list-fi__link-span">{{ link.fields.link.value.text }}</span>
              <span class="link-list-fi__link-icon"><arrow-icon /></span>
            </a>
            <div
              v-else
              class="link-list-fi__link fi-text-18"
            >
              <!-- eslint-disable vue/no-v-html -->
              <span
                v-if="link.fields"
                class="link-list-fi__link-span"
                v-html="link.fields.link.editable"
              />
              <!-- eslint-enable vue/no-v-html -->
              <span class="link-list-fi__link-icon"><arrow-icon /></span>
            </div>
          </li>
        </ul>
      </div>
      <div
        v-if="isEditMode && !fields.linkListElements.length"
        class="link-list-fi__xpe__no-elements fi-col-span-10 fi-col-start-2 fi-mt-24"
      >
        <icon-fi icon="info" /> no link list elements !
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { ArrowIcon, IconFi } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';

export default {
  name: 'LinkListFi',
  components: {
    ArrowIcon,
    ComponentWrapper,
    GridContainerFi,
    IconFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss">
@import './link-list-fi-unscoped';
</style>
